$(document).ready(function () {
    $('.slide_single').owlCarousel({
        loop: true,
        margin: 16,
        nav: false,
        autoWidth: false,
        //center: true,
        items: 2
    });
    
    $('.intro__left--carousel').owlCarousel({
        loop: true,
        nav: false,
        dots : false,
        animateOut: 'fadeOut',
        autoplay : true,
        autoplayTimeout : 4000,
        items: 1
    });
});
